import { useScrollTrigger } from "@material-ui/core";
import React from "react";
import PropTypes from "prop-types";

const ElevationScroll = (props) => {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
    ...(trigger && {
      style: {
        backgroundColor: trigger ? "#191919" : "",
        transition: "background-color 200ms ease-in-out",
        boxShadow: "rgba(0, 0, 0, 0.08) 0px 4px 12px",
      },
    }),
  });
};

ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
  window: PropTypes.func,
};

export default ElevationScroll;
